import React, { Component } from 'react'
import { connect } from 'react-redux'

// Actions
import { getCustomerGroup } from '../../../actions/customerGroup'
import { getCustomerGroupContacts } from '../../../actions/customerGroupContact'

// import components
import Header from '../../../shared/components/Header'
// import LeftMenu from '../../../shared/components/Menus/LeftMenu'
import LeftMenuContent from '../../../shared/components/Menus/LeftMenu/Content'

// Elements
import Button from '../../../shared/elements/button'
import SideMenu from '../../../shared/elements/sideMenu'
import SideMenuItem from '../../../shared/elements/sideMenuItem'
import SideMenuCustomItem from '../../../shared/elements/sideMenuCustomItem'
import CloseButton from '../../../shared/elements/closeButton'

// Views
import View from './View'

// Utils
import { hasSubscriptionPermission } from '../../../utils/auth'
import { translation } from '../../../utils/helpers'

class CustomerGroupContacts extends Component {

  constructor (props) {
    super(props)
    this.state = {
      view: 'list',
      activeItem: {},
      contacts: [],
      customerGroupName: '',
      customerGroupId: 0,
      chainId: 0
    }
    this.headerButtonsRight = this.headerButtonsRight.bind(this)
    this.onSave = this.onSave.bind(this)
    this.onViewFail = this.onViewFail.bind(this)
    this.createView = this.createView.bind(this)
    this.onSelectItem = this.onSelectItem.bind(this)
  }

  componentDidMount () {
    this.getCustomerGroup(this.props)
    this.getCustomerGroupContacts()
    if (typeof this.props.params.contactID !== 'undefined') {
      this.setState({
        view: 'item',
        activeItem: {
          UserId: this.props.params.contactID
        }
      })
    }
  }

  getCustomerGroup (props) {
    if (typeof props.params.customerGroupID !== 'undefined') {
      props.getCustomerGroup(props.params.customerGroupID).then((res) => {
        this.setState({
          customerGroupName: res.data.Name,
          customerGroupId: res.data.CustomerGroupId,
          chainId: props.auth.user.ChainId
        })
      }, (err) => {
        if (err.response.status === 401) {
          this.props.router.replace('/orders')
        }
      })
    }
  }

  getCustomerGroupContacts () {
    return this.props.getCustomerGroupContacts(this.props.params.customerGroupID).then((res) => {
      this.setState({
        contacts: res.data
      })
      if (res.data.length === 0) {
        this.changeView('create')
      }
    }, () => {
      console.log('err')
    })
  }

  changeView (view) {
    let activeItem = this.state.activeItem
    if (view === 'create') {
      activeItem = {}
    }
    this.setState({
      view: view,
      activeItem: activeItem
    })
    this.props.router.replace('/customergroups/' + this.props.params.customerGroupID + '/contacts')
  }

  headerButtonsRight () {
    if (this.state.view === 'create') return null
    if (!hasSubscriptionPermission(this.props.auth, 10, 0) && this.state.contacts.length < 2) return null
    return (
      <div>
        <Button size='m' spacing={0} labelText={translation(1797)} ariaText={translation('2079')} onClick={this.changeView.bind(this, 'create')} />
      </div>
    )
  }

  createView () {
    // If view is create
    if (this.state.view === 'create') {
      const onAdd = () => {
        this.refs.view.getWrappedInstance().addContact()
      }

      return [
        <SideMenuCustomItem key='0' isFixed>
          <Button onClick={onAdd} labelText={translation('1208')} />
        </SideMenuCustomItem>,
        <SideMenuCustomItem key='1' isFixed>
          <Button style='secondary' onClick={this.changeView.bind(this, 'list')} labelText={translation('570')} />
        </SideMenuCustomItem>
      ]
    }

    return this.state.contacts.map(c => {
      return (
        <SideMenuItem
          label={c.Name}
          onClick={() => this.onSelectItem(c)}
          selected={c.UserId === this.state.activeItem.UserId}
          inactive={!c.Active}
          key={c.UserId}
        />
      )
    })
  }

  onSelectItem (item) {
    this.setState({
      view: 'item',
      activeItem: item
    })
    this.props.router.replace('/customergroups/' + this.props.params.customerGroupID + '/contacts')
  }

  onSave (data, type) {
    // console.log('Contacts onSave ', this.state, this.props, data, type)
    let contacts = [...this.state.contacts]
    if (type === 'create') {
      contacts.push({
        Name: data.Name,
        UserId: data.UserId,
        ChainId: this.props.chainId,
        CustomerGroupId: this.props.customerGroupId
      })
      type = 'list'
    } else {
      contacts.map((val, key) => {
        if (val.UserId === data.UserId) {
          val.Name = data.Name
        }
      })
      type = 'item'
    }
    this.setState({
      contacts: contacts,
      view: type,
      chainId: this.props.chainId,
      customerGroupId: this.props.customerGroupId
    })
    // Toastr
    // window.toastr.success(translation('13462'), translation('13424'))
  }

  onViewFail () {
    this.setState({
      view: 'list',
      activeItem: {}
    })
    this.props.router.replace('/customergroups/' + this.props.params.customerGroupID + '/contacts')
  }

  renderView () {
    let chainId = this.props.auth.user.ChainId
    switch (this.state.view) {
      case 'list':
        return <div />
      case 'create':
      case 'item':
        return <View ref='view' item={this.state.activeItem} onSave={this.onSave} chainId={chainId} customerGroupId={this.props.params.customerGroupID} onError={this.onViewFail} />
    }
  }

  render () {
    let headerButtonsGoBack
    headerButtonsGoBack = (router, t) => {
      const goBack = () => {
        this.props.router.replace({
          pathname: '/customergroups/' + this.props.params.customerGroupID
        })
      }
      return (
        <CloseButton ariaText={t('2060')} onClick={goBack} />
      )
    }

    return (
      <div className='customergroup_contacts__screen'>
        <Header router={this.props.router} title={translation('13460') + ' - ' + this.state.customerGroupName} renderRight={this.headerButtonsRight} icon={'menu/Customers-White.png'} showBack headerButtonsGoBack={headerButtonsGoBack} />

        {/* <LeftMenu showFilter items={this.state.contacts} idField={'CustomerId'} showField={'Name'} onSelectItem={this.onSelectItem} selectedItem={this.state.activeItem} view={this.state.view} onRenderCreate={this.createView} /> */}
        <SideMenu showFilter={this.state.view !== 'create'} hideInactiveCheck={this.state.view === 'create'}>
          {this.createView()}
        </SideMenu>

        <LeftMenuContent className='customergroup_contacts__screen--inner'>
          {this.renderView()}
        </LeftMenuContent>
      </div>
    )
  }

}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, { getCustomerGroupContacts, getCustomerGroup })(CustomerGroupContacts)



// WEBPACK FOOTER //
// ./src/app/pages/CustomerGroups/Contacts/index.js